module.exports = __webpack_public_path__ + "static/media/trellis_logo_white_dots_only.f0f49efa.svg";